export const update = {
  updateSuccessfully: '洗剤の更新に成功しました！',
}
